module.exports = __webpack_public_path__ + "static/media/transfer_tr.f1801d60.svg";